<template>
  <div>
    <vx-card>
      <div>
        <h2 class="terminal-title mb-6">[user@localhost /]$</h2>

        <div class="simulation-box terminal-body">
          <div class="command-line flex items-center">
            <span>parted -s</span>
            <v-select
              v-model="c1Opt1"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c1Opt1, incorrect: isCorrect.c1Opt1 === false }"
            />
            <v-select
              v-model="c1Opt2"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c1Opt2, incorrect: isCorrect.c1Opt2 === false }"
            />
            <span class="ml-4">gpt</span>
          </div>
          <div class="command-line flex items-center mt-4">
            <span>parted -s</span>
            <v-select
              v-model="c2Opt1"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c2Opt1, incorrect: isCorrect.c2Opt1 === false }"
            />
            <v-select
              v-model="c2Opt2"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c2Opt2, incorrect: isCorrect.c2Opt2 === false }"
            />
            <v-select
              v-model="c2Opt3"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c2Opt3, incorrect: isCorrect.c2Opt3 === false }"
            />
            <v-select
              v-model="c2Opt4"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c2Opt4, incorrect: isCorrect.c2Opt4 === false }"
            />
            <span class="ml-4">1 10G</span>
          </div>
          <div class="command-line flex items-center mt-4">
            <span>mkfs.</span>
            <v-select
              v-model="c3Opt1"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c3Opt1, incorrect: isCorrect.c3Opt1 === false }"
            />
            <v-select
              v-model="c3Opt2"
              :options="options"
              placeholder="Select Option"
              class="ml-4 w-48"
              :class="{ correct: isCorrect.c3Opt2, incorrect: isCorrect.c3Opt2 === false }"
            />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      isLogPopupVisible: false,
      options: [
        '/dev/sdc',
        'mklabel',
        'lsblk',
        'primary',
        'parted',
        '/dev/dev1',
        'ext3',
        'mkdir',
        'gpt',
        'secondary',
        'sdc',
        'sdb',
        'ext2',
        '/dev/sdc1',
        '/data',
        'mkpart',
        'ext4',
      ],
      c1Opt1: '',
      c1Opt2: '',
      c2Opt1: '',
      c2Opt2: '',
      c2Opt3: '',
      c2Opt4: '',
      c3Opt1: '',
      c3Opt2: '',
      isCorrect: {
        c1Opt1: null,
        c1Opt2: null,
        c2Opt1: null,
        c2Opt2: null,
        c2Opt3: null,
        c2Opt4: null,
        c3Opt1: null,
        c3Opt2: null,
      },
    };
  },
  methods: {
    showLogPopup() {
      this.isLogPopupVisible = true;
    },
    markSimulation() {
      let totalScore = 0;

      // Grade first command
      this.isCorrect.c1Opt1 = this.c1Opt1 === '/dev/sdc';
      if (this.isCorrect.c1Opt1) {
        totalScore++;
      }

      this.isCorrect.c1Opt2 = this.c1Opt2 === 'mklabel';
      if (this.isCorrect.c1Opt2) {
        totalScore++;
      }

      // Grade second command
      this.isCorrect.c2Opt1 = this.c2Opt1 === '/dev/sdc';
      if (this.isCorrect.c2Opt1) {
        totalScore++;
      }

      this.isCorrect.c2Opt2 = this.c2Opt2 === 'mkpart';
      if (this.isCorrect.c2Opt2) {
        totalScore++;
      }

      this.isCorrect.c2Opt3 = this.c2Opt3 === 'primary';
      if (this.isCorrect.c2Opt3) {
        totalScore++;
      }

      this.isCorrect.c2Opt4 = this.c2Opt4 === 'ext4';
      if (this.isCorrect.c2Opt4) {
        totalScore++;
      }

      // Grade third command
      this.isCorrect.c3Opt1 = this.c3Opt1 === 'ext4';
      if (this.isCorrect.c3Opt1) {
        totalScore++;
      }

      this.isCorrect.c3Opt2 = this.c3Opt2 === '/dev/sdc1';
      if (this.isCorrect.c3Opt2) {
        totalScore++;
      }

      if (totalScore === 8) {
        this.$emit('simulation_full_correct', totalScore);
      } else {
        this.$emit('simulation_getting_there', totalScore);
      }
    },
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.terminal-title {
  font-family: monospace;
  font-size: 24px; /* Increased font size */
  color: #0053ff;
}
.simulation-container {
  padding: 20px; /* Increased padding */
  border-radius: 0 0 8px 8px;
  background-color: #282828;
}
.command-line {
  font-family: monospace;
  font-size: 20px; /* Increased font size */
}
.dropdown {
  background-color: #333;
  color: #c5c5c5;
  border: 1px solid #555;
  border-radius: 4px;
  padding: 10px; /* Increased padding for larger dropdowns */
  font-size: 18px; /* Increased font size */
}
.correct {
  border-color: #28a745;
  color: #28a745;
}
.incorrect {
  border-color: #dc3545;
  color: #dc3545;
}
.btn-view-log {
  background-color: #007bff;
  color: #fff;
  padding: 15px 30px; /* Increased button size */
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 18px; /* Increased font size */
}
.btn-view-log:hover {
  background-color: #0056b3;
}
.btn-grade {
  background-color: #28a745;
  color: #fff;
  padding: 15px 30px; /* Increased button size */
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 18px; /* Increased font size */
}
.btn-grade:hover {
  background-color: #218838;
}
.log-file-output {
  font-family: monospace;
  background-color: #f0f0f0;
  padding: 20px; /* Increased padding */
  border-radius: 8px;
  font-size: 18px; /* Increased font size */
}
</style>
